import { Pubsub } from '@/common/utils/pubsub';
import { $k18n } from '@/common/i18n';
import { useQuery, useQuerys } from '@/hooks/useQuery';

// 秒杀状态2（进行中）/4（限购）/5（无秒杀库存）时，展示秒杀信息
export const showFlashActivity = (status) => [2, 4, 5].includes(status);

export const getBottomBenfitParams = (pageRawData) => {
    let log = '';
    // 上报ugc埋点
    if (pageRawData?.displaySpuUgc) {
        log = `${log},UGC_multi_select`;
    }
    return log;
};

export const useExtParamsObject = () => {
    const ext = useQuery<string>('extParams') || '';
    const cc = useQuery('cc') as string;
    let res: any = {};
    try {
        res = JSON.parse(decodeURIComponent(ext || '{}'));
        if (useQuery('source') === 'out_share') {
            res.cT = cc === 'IM_CONVERSATION' ? 7 : 6;
        }
        if (useQuery('via') === '1') {
            res.cT = 0;
        }
    } catch (e) {
        console.log('json key error', e);
    }
    return res;
};

// RN中使用 URL.searchParams 会报错，所以使用此方法
function getURLParams(parameterName, url) {
    const name = parameterName.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return null;
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function useExtParamsFromUrl() {
    const { cc, source } = useQuerys();

    // 通过列表中下发链接的参数获取extParams
    const getExtParamsFromUrl = (url: string) => {
        // 获取链接的参数
        const ext = getURLParams('extParams', url) || '';
        let res;
        try {
            res = JSON.parse(decodeURIComponent(ext || '{}'));
            console.log('extParams', res);
            if (source === 'out_share') {
                res.cT = cc === 'IM_CONVERSATION' ? 7 : 6;
            }
        } catch (e) {
            console.log('json key error', e);
        }
        return res;
    };

    return { getExtParamsFromUrl };
}

export const useChannelCouponTag = (currentChannelType) => {
    const componentName = useQuery<string>('componentName');
    const extParams = useExtParamsObject();
    const cT = +extParams?.cT;

    // 目前只有商详透出
    if (!['Detail'].includes(componentName)) {
        return '';
    }

    // 短视频
    if (cT === 1 && currentChannelType === 6) {
        return $k18n({ id: 'k_474807' });
    }

    // 短视频单双列推荐
    if ([12, 13].includes(cT) && currentChannelType === 9) {
        return $k18n({ id: 'k_474807' });
    }

    return '';
};

export const detailPubsub = new Pubsub();
